export class CompleteAmbassadorProfileDTO {
    profilePicUrl: any;
    profilePicId: number;
    firstName: string = "";
    lastName: string = "";
    dob: string = "";
    email: string = "";
    gender: string = "";
    phone: string = "";
    address: string = "";
    language: string = "";
    city: string = "";
    state: string = "";
    zipCode: string = "";
    skills: string[] = [];
    mission: string = "";
    engagementLevel: string = "";
    commitmentLength: string = "";
    referralCode: string = "";
    profileCompleted: boolean = false;

    // constructor(data: Partial<CompleteAmbassadorProfileDTO> = {}){
    //     Object.assign(this,data);
    // }
    constructor(data: Partial<Omit<CompleteAmbassadorProfileDTO, 'skills'>> & { skills?: string | string[] } = {}) {
  if (typeof data.skills === 'string') {
    this.skills = data.skills.split(',').map(skill => skill.trim());
  } else if (Array.isArray(data.skills)) {
    this.skills = data.skills;
  } else {
    this.skills = [];
  }

  Object.assign(this, data);
}

    
  }
